/**
 * Created by rickborst on 26/04/2017.
 */
import Image from 'models/image';

class League {

    constructor (options = {}) {

        this.name = options.name || '';
        this.image = options.image
            ? new Image(options.image)
            : null;

        return this;
    }
}

export default League;


// WEBPACK FOOTER //
// ./src/js/models/league.js